import { Menu, MenuLocationEnum, PostCardListFragment, MenuItem } from 'gql/graphql-operations';
import { BreadcrumbsItemType } from 'ui/src/components/Breadcrumbs';
import UiMenuItem from 'ui/src/data/MenuItem';

export const POSTS_PER_PAGE = 15;
export const RELATED_ARTICLES = 6;
export const NAVBAR_SCROLL_TO_COLLAPSE = 100;
export const NAVBAR_SCROLL_TO_READING = 150;

export const FULL_URL = `${process.env.NEXT_PUBLIC_HOSTNAME}${process.env.NEXT_PUBLIC_BASE_PATH}`;

export const calculateOffset = (pageNum: number | string | unknown): number => {
  const pageNo: number = Number(pageNum); // convert to a number

  if (!pageNo || pageNo < 2) return 0;

  // with 10 per page, for page 5, it will be (5-1) * 10 = 40
  return (pageNo - 1) * POSTS_PER_PAGE;
};

export const handlePostData = (post: PostCardListFragment | null) => ({
  ...post,
  author: post?.author ?? {},
  categories: post?.categories ?? { nodes: null },
  featuredImage: post?.featuredImage ?? {},
  id: post?.id ?? '',
  slug: post?.slug ?? '',
  title: post?.title ?? '',
});

export const DEFAULT_REVALIDATION_TIME = parseInt(process.env.NEXT_PUBLIC_REVALIDATION_TIME || '43200', 10); // in seconds

export const BLOG_TITLE = 'Blog - BairesDev';

export const BREADCRUMBS_BASE: BreadcrumbsItemType[] = [
  {
    href: process.env.NEXT_PUBLIC_HOSTNAME ?? 'https://www.bairesdev.com/',
  },
  {
    label: 'Blog',
    href: '/',
  },
];

export const LIST_POST_DESCRIPTION = '';

export const LIST_CATEGORY_DESCRIPTION = '';

export const LIST_TAG_DESCRIPTION = '';

/**
 * Gets the object from GraphQL and builds the menu tree according to MenuItem type
 *
 * @param menuItems list from GQL
 * @param placement enum MenuLocations
 * @returns Array of ENABLED menus - MenuItem[]
 */
export function getMenuTree(
  menuItems: Partial<Record<MenuLocationEnum, Partial<Menu> | null>>,
  placement: MenuLocationEnum,
) {
  const buildMenuTree = (items?: MenuItem[]): UiMenuItem[] =>
    items?.reduce(
      (acc: UiMenuItem[], item) =>
        item.menuItemOptions?.enabled
          ? acc.concat({
              id: item.id,
              path: item.url || '#',
              label: item.label || '',
              rel: item.linkRelationship,
              children: item.childItems?.nodes.length ? buildMenuTree(item.childItems.nodes) : [],
            })
          : acc,
      [],
    ) ?? [];

  return buildMenuTree(menuItems[placement]?.menuItems?.nodes);
}

export type BlogSearch = {
  term: string;
  results: string[];
  total: number;
};

export type QuickSearch = {
  term: string;
  results: {
    id: string;
    title: string;
    slug: string;
  }[];
};

export type Links = {
  href: string;
  rel: string;
}[];
